/* ============================================================================
   Harmony — Demande de catalogue
   ----------------------------------------------------------------------------
   - Deux boutons de mode (email / postal), bloc adresse révélé si postal
   - Validation : champs communs toujours requis ; adresse requise si postal
   - POST vers le webhook n8n harmony-catalogue
   ========================================================================== */

(function () {
	'use strict';

	function initSection(root) {
		if (!root || root.__harmonyCatInit) return;
		root.__harmonyCatInit = true;

		/* ---- Connexion n8n (en dur) ---- */
		var ENDPOINT = 'https://n8n.octavio.pro/webhook/harmony-catalogue';

		/* ---- Textes ---- */
		var CFG = {};
		var cfgEl = root.querySelector('[data-harmony-cat-config]');
		if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; } }
		var T = CFG.texts || {};
		function txt(k, f) { return (T[k] != null && T[k] !== '') ? T[k] : f; }

		/* ---- DOM ---- */
		var inner = root.querySelector('[data-cat-inner]');
		var modesWrap = root.querySelector('[data-modes]');
		var modeBtns = root.querySelectorAll('[data-mode]');
		var addressBox = root.querySelector('[data-address]');
		var submitBtn = root.querySelector('[data-action="submit-catalogue"]');

		var state = { mode: null };

		/* ---- Helpers ---- */
		function val(sel) { var e = root.querySelector(sel); return e ? e.value.trim() : ''; }

		/* ---- Choix du mode ---- */
		Array.prototype.forEach.call(modeBtns, function (btn) {
			btn.addEventListener('click', function () {
				state.mode = btn.getAttribute('data-mode');
				Array.prototype.forEach.call(modeBtns, function (b) {
					var on = b === btn;
					b.classList.toggle('is-selected', on);
					b.setAttribute('aria-pressed', on ? 'true' : 'false');
				});
				// Révéler l'adresse si postal
				addressBox.hidden = (state.mode !== 'postal');
				// Effacer une éventuelle erreur de mode
				clearModeError();
			});
		});

		function clearModeError() {
			var err = root.querySelector('[data-error-for="mode"]');
			if (err) err.remove();
			modesWrap.classList.remove('harmony-cat__modes--error');
		}
		function showModeError() {
			clearModeError();
			var err = document.createElement('span');
			err.className = 'harmony-cat__field-error';
			err.setAttribute('data-error-for', 'mode');
			err.textContent = txt('modeRequired', 'Merci de choisir un mode de réception.');
			modesWrap.parentNode.insertBefore(err, modesWrap.nextSibling);
		}

		/* ---- Validation ---- */
		var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		function showFieldError(input, msg) {
			input.classList.add('harmony-cat__input--error');
			var err = root.querySelector('[data-error-for="' + input.id + '"]');
			if (err) { err.textContent = msg; err.hidden = false; }
		}
		function clearFieldError(input) {
			input.classList.remove('harmony-cat__input--error');
			var err = root.querySelector('[data-error-for="' + input.id + '"]');
			if (err) { err.hidden = true; err.textContent = ''; }
		}

		function validate() {
			var ok = true;
			var firstInvalid = null;

			// Champs communs toujours requis
			var required = root.querySelectorAll('[data-required]');
			Array.prototype.forEach.call(required, function (input) {
				clearFieldError(input);
				var v = (input.value || '').trim();
				if (!v) {
					showFieldError(input, 'Ce champ est requis.');
					ok = false; if (!firstInvalid) firstInvalid = input;
				} else if (input.getAttribute('data-type') === 'email' && !EMAIL_RE.test(v)) {
					showFieldError(input, 'Adresse e-mail invalide.');
					ok = false; if (!firstInvalid) firstInvalid = input;
				}
			});

			// Mode obligatoire
			if (!state.mode) {
				showModeError();
				ok = false;
			}

			// Champs adresse requis seulement si postal
			if (state.mode === 'postal') {
				var addr = root.querySelectorAll('[data-addr-required]');
				Array.prototype.forEach.call(addr, function (input) {
					clearFieldError(input);
					var v = (input.value || '').trim();
					if (!v) {
						showFieldError(input, 'Ce champ est requis.');
						ok = false; if (!firstInvalid) firstInvalid = input;
					}
				});
			}

			if (firstInvalid) firstInvalid.focus();
			return ok;
		}

		// Effacer l'erreur d'un champ à la correction
		root.addEventListener('input', function (e) {
			if (e.target && e.target.classList && e.target.classList.contains('harmony-cat__input')) {
				clearFieldError(e.target);
			}
		});

		/* ---- État de chargement ---- */
		function setBtnLoading(on) {
			if (!submitBtn) return;
			if (on) {
				submitBtn._label = submitBtn.innerHTML;
				submitBtn.disabled = true;
				submitBtn.style.opacity = '0.6';
				submitBtn.innerHTML = '<span>Envoi…</span>';
			} else {
				submitBtn.disabled = false;
				submitBtn.style.opacity = '';
				if (submitBtn._label) submitBtn.innerHTML = submitBtn._label;
			}
		}

		/* ---- Soumission ---- */
		submitBtn.addEventListener('click', function () {
			if (!validate()) return;

			var data = {
				mode: state.mode,
				prenom: val('#hc-prenom'),
				nom: val('#hc-nom'),
				email: val('#hc-email'),
				telephone: val('#hc-tel')
			};
			if (state.mode === 'postal') {
				data.adresse = val('#hc-adresse');
				data.code_postal = val('#hc-cp');
				data.ville = val('#hc-ville');
				data.pays = val('#hc-pays');
			}

			setBtnLoading(true);
			fetch(ENDPOINT, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			}).then(function (r) {
				if (!r.ok) throw new Error('http ' + r.status);
				return r.json();
			}).then(function () {
				var msg = (state.mode === 'postal')
					? txt('successPostal', 'Votre catalogue papier part bientôt vers chez vous.')
					: txt('successEmail', 'Vérifiez votre boîte mail, votre catalogue vous attend.');
				showState('✓', txt('successTitle', 'Catalogue en route !'), msg);
			}).catch(function () {
				setBtnLoading(false);
				alert(txt('errorText', 'Une erreur est survenue. Merci de réessayer dans un instant.'));
			});
		});

		function showState(icon, title, msg) {
			inner.innerHTML = '<div class="harmony-cat__state">' +
				'<div class="harmony-cat__state-icon" aria-hidden="true">' + icon + '</div>' +
				'<h2 class="harmony-cat__state-title h2">' + title + '</h2>' +
				'<p class="harmony-cat__state-text">' + msg + '</p></div>';
		}
	}

	function boot() {
		Array.prototype.forEach.call(document.querySelectorAll('.harmony-cat[data-section-id]'), initSection);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else { boot(); }
	document.addEventListener('shopify:section:load', function (e) {
		var s = e.target.querySelector('.harmony-cat[data-section-id]');
		if (s) initSection(s);
	});
})();
